import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import './moduleErrorBoundary.less';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

interface Props {
  t: any;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ModuleErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
    errorInfo: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  private handleCopyError = async () => {
    const errorDetails = {
      message: this.state.error?.message,
      stack: this.state.error?.stack,
      componentStack: this.state.errorInfo?.componentStack,
    };

    const errorText = JSON.stringify(errorDetails, null, 2);
    await navigator.clipboard
      .writeText(errorText)
      .then(() => message.success('Error copied to clipboard'))
      .catch((e) =>
        message.warning('Error copied to clipboard (fallback method)')
      );
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="module-error-boundary">
          <div className="error-content">
            <h3>
              {this.props.t?.moduleError?.title ||
                'We have problem to show the results'}
            </h3>
            <Button
              type="primary"
              className="btn-style-5"
              icon={<CopyOutlined />}
              onClick={this.handleCopyError}
            >
              {this.props.t?.moduleError?.copyError || 'Copy Error'}
            </Button>
            <div className="error-details">
              <pre>{this.state.error?.message}</pre>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
